import AsyncBlockService from 'services/async-block-service';
var BlockView = require('views/block/base-block-view');
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');

var GlossaryView = BlockView.extend({
  regions: {
    'glossary': '.glossary'
  },
  initialize: function() {
    if(this.model.get('definition_key')) {
      this.model.set('definitions', LocaleService.t(this.model.get('definition_key'), {returnObjects: true}));
    }
    this.model.set('footnotes', this.model.get('definitions').reduce((refs, def) => {
      if(def.reference) {
        refs.push(def.reference);
        def.footnote = refs.length;
      }
      return refs;
    }, []));

    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    let defs = new Chaplin.Collection(this.model.get('definitions'));
    AsyncBlockService.load([ 'glossary' ], [ 'views/block/glossary/glossary-collection-view' ]).then(([ GlossaryCollectionView ]) => {
      var glossaryCollectionView = new GlossaryCollectionView({
        region: 'glossary',
        collection: defs
      });
      this.subview('glossary', glossaryCollectionView);
    });
    AhoyService.track('glossary', {action: 'loaded'});
  },
  play: function() {
    this.readyToGo();
  }
});

module.exports = GlossaryView;
